import Vue from 'vue'
import Router from 'vue-router'
import Phrases from './views/Phrases.vue'
import Languages from './views/Languages.vue'
import DialogTree from './views/DialogTree.vue'
import Devices from './views/Devices.vue'
import Users from './views/Users.vue'
import Settings from './views/Settings.vue'
import TranslatorView from './views/TranslatorView.vue'
import TranslateTree from './views/TranslateTree.vue'
import MissingTranslation from './views/MissingTranslation.vue'
import ReviewTree from './views/ReviewTree.vue'
import Links from './views/Links.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/phrases',
      name: 'phrases',
      component: Phrases
    }, {
      path: '/translator',
      name: 'translator',
      component: TranslatorView
    }, {
      path: '/translatetree',
      name: 'translatetree',
      component: TranslateTree
    }, {
      path: '/',
      name: 'languages',
      component: Languages
    }, {
      path: '/users',
      name: 'users',
      component: Users
    }, {
      path: '/dialogs',
      name: 'dialogs',
      component: DialogTree
    }, {
      path: '/devices',
      name: 'devices',
      component: Devices
    }, {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/missingtranslation',
      name: 'missingtranslation',
      component: MissingTranslation
    },
    {
      path: '/review',
      name: 'reviewtree',
      component: ReviewTree
    },
    {
      path: '/links',
      name: 'links',
      component: Links
    }
  ]
})
